// /src/pages/Capacitacion.tsx
import React, { useState } from 'react';
import {
  Box,
  Heading,
  SimpleGrid,
  Card,
  CardBody,
  Text,
  Button,
  Badge,
  VStack,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { ICurso } from '../types';
import { mockCursos } from '../mocks/cursos';

export const Capacitacion: React.FC = () => {
  const [cursos] = useState<ICurso[]>(mockCursos);
  const navigate = useNavigate();

  return (
    <Box>
      <Heading size="lg" mb={6}>
        Módulo de Capacitación
      </Heading>

      <SimpleGrid columns={[1, 2, 3]} spacing={6}>
        {cursos.map((curso) => (
          <Card key={curso.id} boxShadow="md" _hover={{ boxShadow: 'lg', transform: 'translateY(-4px)' }} transition="all 0.2s">
            <CardBody>
              <VStack align="stretch" spacing={4}>
                <Box>
                  {curso.completado && (
                    <Badge colorScheme="green" mb={2}>
                      ✓ Completado
                    </Badge>
                  )}
                  <Heading size="md" mb={2}>
                    {curso.titulo}
                  </Heading>
                  <Text fontSize="sm" color="gray.600" noOfLines={3}>
                    {curso.descripcion}
                  </Text>
                </Box>
                
                <Button
                  colorScheme="blue"
                  onClick={() => navigate(`/capacitacion/${curso.id}`)}
                >
                  Ver Curso
                </Button>
              </VStack>
            </CardBody>
          </Card>
        ))}
      </SimpleGrid>
    </Box>
  );
};
